export const toastMessageConfig = { life: 3000 };
